import { render, staticRenderFns } from "./JournalDetailRow.vue?vue&type=template&id=579466a1&scoped=true"
import script from "./JournalDetailRow.vue?vue&type=script&lang=js"
export * from "./JournalDetailRow.vue?vue&type=script&lang=js"
import style0 from "./JournalDetailRow.vue?vue&type=style&index=0&id=579466a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579466a1",
  null
  
)

export default component.exports